
  <div class="card text-left">
    <div class="card-header bg-light">
      <h4 class="card-title mb-0">
        <i class="fas fa-pencil-alt pr-2"></i> Copiar Causas e Consequências de um Risco Identificado
      </h4>
    </div>
    <div class="card-body wrapper m-0">      
      <div class="row mb-1">
        <div class="col-md-2">
          Riscos Identificados:
        </div>
        <div class="col-md-6">
          <ng-select
            id="selectCriterio"
            [(ngModel)]="riscoSelecionado">
            <ng-option [value]="obj.controle" *ngFor="let obj of objPrincipal.riscos">{{ obj.descricaoRisco }}</ng-option>
          </ng-select>
        </div>
      </div>      
    </div>
    <div class="card-footer">
      <div class="d-flex w-100 justify-content-between align-items-center">
        <div class="list2">
          <div class="btn-group">
            <button class="btn btn-primary btn-sm mr" (click)="salvar(false)">
                <i class="far fa-save"></i> Copiar
            </button>            
          </div>
          &nbsp;
          <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
            <i class="fas fa-times"></i> Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>

